(() => {
  if (customElements.get('studio-finder-popup')) return;

  class StudioFinderPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-finder-popup-open]');
      this.closeButton = this.querySelector('[data-finder-popup-close]');
      if (!this.dialog || !this.trigger || !this.closeButton || !this.dialog.showModal) return;

      this.openPopup = (event) => {
        if (event.type === 'keydown' && event.key !== ' ') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('studio-finder-popup-open');
        this.dialog.scrollTop = 0;
        const finder = this.dialog.querySelector('[data-studio-product-finder]');
        if (finder) finder.scrollTop = 0;
        const input = this.dialog.querySelector('[data-studio-product-finder-input]');
        const target = input && !input.closest('[hidden]') ? input : this.closeButton;
        target.focus({preventScroll: true});
      };
      this.closePopup = () => this.dialog.close();
      this.onEscape = (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.closePopup();
      };
      this.onClose = () => {
        if (!document.querySelector('.studio-finder-popup__dialog[open]')) {
          document.documentElement.classList.remove('studio-finder-popup-open');
        }
        if (this.trigger.isConnected) this.trigger.focus({preventScroll: true});
      };
      let backdropPointer = false;
      this.onPointerDown = (event) => { backdropPointer = event.target === this.dialog; };
      this.onBackdropClick = (event) => {
        if (backdropPointer && event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
        backdropPointer = false;
      };
      this.trigger.setAttribute('role', 'button');
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-controls', this.dialog.id);
      this.trigger.addEventListener('click', this.openPopup);
      this.trigger.addEventListener('keydown', this.openPopup);
      this.closeButton.addEventListener('click', this.closePopup);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onEscape);
      this.dialog.addEventListener('pointerdown', this.onPointerDown);
      this.dialog.addEventListener('click', this.onBackdropClick);
    }

    disconnectedCallback() {
      if (!this.openPopup) return;
      if (this.dialog.open) this.dialog.close();
      this.onClose();
      this.trigger.removeEventListener('click', this.openPopup);
      this.trigger.removeEventListener('keydown', this.openPopup);
      this.closeButton.removeEventListener('click', this.closePopup);
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('keydown', this.onEscape);
      this.dialog.removeEventListener('pointerdown', this.onPointerDown);
      this.dialog.removeEventListener('click', this.onBackdropClick);
    }
  }
  customElements.define('studio-finder-popup', StudioFinderPopup);
})();
